module.exports = __webpack_public_path__ + "img/step3.42d12a5.png";